import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50" aria-labelledby="cta-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Image Banner */}
        <div className="rounded-2xl overflow-hidden h-48 md:h-72">
          <img
            src="https://readdy.ai/api/search-image?query=Creative%20flat%20lay%20composition%20of%20colorful%20sneakers%20folded%20hoodies%20caps%20and%20shopping%20bags%20arranged%20in%20a%20circular%20pattern%20on%20a%20smooth%20light%20grey%20surface%20with%20soft%20diffused%20daylight%20cheerful%20vibrant%20yet%20clean%20aesthetic%20modern%20ecommerce%20lifestyle%20photography%20inviting%20energy%20negative%20space%20in%20center&width=1400&height=560&seq=cta-banner-v3-kakobuy&orientation=landscape"
            alt="Kakobuy Spreadsheet products collection"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>

        {/* Content */}
        <div className="mt-12 md:mt-14 text-center max-w-2xl mx-auto">
          <h2 id="cta-heading" className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            Ready to shop <span className="italic text-foreground-400 font-normal">smarter</span>?
            <br />
            Start exploring <strong>verified finds</strong> today.
          </h2>

          <p className="mt-4 text-foreground-500 text-sm md:text-base">
            Join thousands of buyers who use the Kakobuy spreadsheet to discover the best deals on sneakers, streetwear, and luxury items.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now on Kaspreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-foreground-300 text-foreground-700 font-medium text-sm md:text-base hover:bg-foreground-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Browse kakobuy spreadsheet
              <i className="ri-external-link-line text-xs"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}